import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Translator, { __ } from "services/Translator";
import api from "services/api";

const GameItem = ({ game, isAuthenticated, props }) => {
  const [visible, setVisible] = useState(true);
  const [processed, setProcessed] = useState(false);
  const imageRef = useRef(null);
  // const loaderImage = require("assets/zangabet/images/games/game-loader.gif");
  const loaderImage = require("assets/chilirojo/images/logos/logo.webp");
  const [gameSnapshotUrl, setGameSnapshotUrl] = useState(loaderImage);
  const defaultImage = require("assets/chilirojo/images/games/default.png");

  const hideNoImageFoundGames = () => {
    // Fallback to a default image instead of hiding the game card
    setGameSnapshotUrl(defaultImage);
    setVisible(true);
  };

  const fixImageRatio = (event) => {
    const img = event.target;
    if (!processed) {
      img.src = game.game_snapshot_url;
      img.onload = () => {
        img.height = img.width * 1.31;
        setGameSnapshotUrl(game.game_snapshot_url);
        setProcessed(true);
      };
    } else {
      // Recalculate height on resize or when called again
      img.height = img.width * 1.31;
    }
  };

  // Function to handle browser resize - using ref for direct access
  const handleResize = () => {
    if (processed && gameSnapshotUrl !== loaderImage && imageRef.current) {
      // Throttled resize for better performance
      if (!window.resizeThrottle) {
        window.resizeThrottle = setTimeout(() => {
          if (imageRef.current) {
            const img = imageRef.current;
            img.style.height = "auto";
            img.height = img.width * 1.31;
          }
          window.resizeThrottle = null;
        }, 16); // ~60fps
      }
    }
  };

  useEffect(() => {
    setGameSnapshotUrl(loaderImage);
    setProcessed(false);
  }, [game.id, loaderImage]);

  // Add resize event listener
  useEffect(() => {
    // Only add resize listener when image is processed and visible
    if (processed && gameSnapshotUrl !== loaderImage) {
      window.addEventListener("resize", handleResize);

      // Cleanup function to remove event listener
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }
  }, [processed, gameSnapshotUrl, loaderImage]);

  const [isFavorite, setIsFavorite] = useState(game.is_favorite_game);

  const toggleFavoriteGame = async () => {
    const response = await api.post("/toggle-favorite-game", {
      gameId: game.id,
    });
    if (response.status === 200) {
      setIsFavorite(response.data.status === "added");
    }
  };

  if (!visible) return null;
  return (
    <>
      <div className={"gameItemBlock "}>
        <div className="game_thumb">
          <Link hrefLang={Translator.getSelectedLanguage().code} to={"/play/" + game.slug}>
            <img
              ref={imageRef}
              onLoad={fixImageRatio}
              src={gameSnapshotUrl}
              onError={hideNoImageFoundGames}
              alt={game.game_name ?? ""}
            />
          </Link>

          <div className="favorite_icon_container">
            {!isAuthenticated ? (
              <Link
                hreflang={Translator.getSelectedLanguage().code}
                onClick={() => {
                  props.setModalSignUpPropsData(true);
                  setTimeout(() => {
                    props.setModalSignUpPropsData(false);
                  }, 500);
                }}
                className="favorite_icon"
              >
                <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clipPath="url(#clip0_2081_1449)">
                    <path
                      d="M5.4 0C2.4 0 0 2.4 0 5.4C0 6.4 0.5 7.3 0.9 7.9C1.3 8.5 1.8 8.9 1.8 8.9L9.5 16.6L10 17.1L10.5 16.6L18.2 9C18.2 9 20 7.4 20 5.4C20 2.4 17.6 0 14.6 0C12.1 0 10.6 1.5 10 2.1C9.4 1.5 7.8 0 5.4 0ZM5.4 1.4C7.5 1.4 9.5 3.5 9.5 3.5L10 4.1L10.5 3.5C10.5 3.5 12.5 1.4 14.6 1.4C16.8 1.4 18.5 3.2 18.5 5.3C18.5 6.4 17.2 7.9 17.2 7.9L10 15.2L2.8 7.9C2.8 7.9 2.5 7.6 2.1 7.1C1.7 6.6 1.4 5.9 1.4 5.4C1.4 3.2 3.2 1.4 5.4 1.4Z"
                      fill="#4698ED"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2081_1449">
                      <rect width="20" height="17.2" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </Link>
            ) : (
              <Link
                hreflang={Translator.getSelectedLanguage().code}
                onClick={toggleFavoriteGame}
                className="favorite_icon"
              >
                {isFavorite ? (
                  <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_2081_3472)">
                      <path
                        d="M14.6 0C12.5 0 10.8 1.3 10 2C9.2 1.3 7.4 0 5.4 0C2.4 0 0 2.4 0 5.4C0 7.2 1.7 8.9 1.8 9L10 17.2L18.2 9C18.3 8.9 20 7.2 20 5.4C20 2.4 17.6 0 14.6 0Z"
                        fill="#4698ED"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_2081_3472">
                        <rect width="20" height="17.2" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                ) : (
                  <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_2081_1449)">
                      <path
                        d="M5.4 0C2.4 0 0 2.4 0 5.4C0 6.4 0.5 7.3 0.9 7.9C1.3 8.5 1.8 8.9 1.8 8.9L9.5 16.6L10 17.1L10.5 16.6L18.2 9C18.2 9 20 7.4 20 5.4C20 2.4 17.6 0 14.6 0C12.1 0 10.6 1.5 10 2.1C9.4 1.5 7.8 0 5.4 0ZM5.4 1.4C7.5 1.4 9.5 3.5 9.5 3.5L10 4.1L10.5 3.5C10.5 3.5 12.5 1.4 14.6 1.4C16.8 1.4 18.5 3.2 18.5 5.3C18.5 6.4 17.2 7.9 17.2 7.9L10 15.2L2.8 7.9C2.8 7.9 2.5 7.6 2.1 7.1C1.7 6.6 1.4 5.9 1.4 5.4C1.4 3.2 3.2 1.4 5.4 1.4Z"
                        fill="#4698ED"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_2081_1449">
                        <rect width="20" height="17.2" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                )}
              </Link>
            )}
          </div>
          <div className="game_overlay">
            {!!game.rtp && (
              <div className="rtp_info">
                <div className="left rtp_text">
                  RTP: <span>{game.rtp}%</span>
                </div>
              </div>
            )}
            <h3 className="game_name">{game.game_name}</h3>
            <div className="">
              {!isAuthenticated ? (
                <Link
                  hreflang={Translator.getSelectedLanguage().code}
                  onClick={() => {
                    props.setModalSignUpPropsData(true);
                    setTimeout(() => {
                      props.setModalSignUpPropsData(false);
                    }, 500);
                  }}
                  className="game_action"
                >
                  {/* <i className="fas fa-play"></i> */}
                  {/* <span>{__("Sign Up")}</span> */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xlink="http://www.w3.org/1999/xlink"
                    width="50.637"
                    height="52"
                    viewBox="0 0 50.637 52"
                  >
                    <defs>
                      <filter id="Polygon_36" x="7" y="4" width="43.636" height="48" filterUnits="userSpaceOnUse">
                        <feOffset dy="3" input="SourceAlpha" />
                        <feGaussianBlur stdDeviation="3" result="blur" />
                        <feFlood flood-color="#fff" flood-opacity="0.322" />
                        <feComposite operator="in" in2="blur" />
                        <feComposite in="SourceGraphic" />
                      </filter>
                    </defs>
                    <g id="Group_1545" data-name="Group 1545" transform="translate(-792 -546)">
                      <g
                        id="Ellipse_251"
                        data-name="Ellipse 251"
                        transform="translate(792 546)"
                        fill="none"
                        stroke="#fff"
                        stroke-width="5"
                      >
                        <circle cx="25" cy="25" r="25" stroke="none" />
                        <circle cx="25" cy="25" r="22.5" fill="none" />
                      </g>
                      <g transform="matrix(1, 0, 0, 1, 792, 546)" filter="url(#Polygon_36)">
                        <path
                          id="Polygon_36-2"
                          data-name="Polygon 36"
                          d="M11.548,5.9a4,4,0,0,1,6.9,0l8.025,13.716a4,4,0,0,1-3.452,6.02H6.975a4,4,0,0,1-3.452-6.02Z"
                          transform="translate(41.64 10) rotate(90)"
                          fill="#fff"
                        />
                      </g>
                    </g>
                  </svg>
                </Link>
              ) : (
                <Link
                  hreflang={Translator.getSelectedLanguage().code}
                  className="game_action"
                  to={"/play/" + game.slug}
                >
                  {/* <i className="fas fa-play"></i> */}
                  {/* <span>{__("Play")}</span> */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xlink="http://www.w3.org/1999/xlink"
                    width="50.637"
                    height="52"
                    viewBox="0 0 50.637 52"
                  >
                    <defs>
                      <filter id="Polygon_36" x="7" y="4" width="43.636" height="48" filterUnits="userSpaceOnUse">
                        <feOffset dy="3" input="SourceAlpha" />
                        <feGaussianBlur stdDeviation="3" result="blur" />
                        <feFlood flood-color="#fff" flood-opacity="0.322" />
                        <feComposite operator="in" in2="blur" />
                        <feComposite in="SourceGraphic" />
                      </filter>
                    </defs>
                    <g id="Group_1545" data-name="Group 1545" transform="translate(-792 -546)">
                      <g
                        id="Ellipse_251"
                        data-name="Ellipse 251"
                        transform="translate(792 546)"
                        fill="none"
                        stroke="#fff"
                        stroke-width="5"
                      >
                        <circle cx="25" cy="25" r="25" stroke="none" />
                        <circle cx="25" cy="25" r="22.5" fill="none" />
                      </g>
                      <g transform="matrix(1, 0, 0, 1, 792, 546)" filter="url(#Polygon_36)">
                        <path
                          id="Polygon_36-2"
                          data-name="Polygon 36"
                          d="M11.548,5.9a4,4,0,0,1,6.9,0l8.025,13.716a4,4,0,0,1-3.452,6.02H6.975a4,4,0,0,1-3.452-6.02Z"
                          transform="translate(41.64 10) rotate(90)"
                          fill="#fff"
                        />
                      </g>
                    </g>
                  </svg>
                </Link>
              )}
            </div>

            <div className="game_info">
              <div className="left">
                <h4 className="game_provider_name">{game.provider?.name}</h4>
              </div>
              <div className="right"></div>
            </div>
          </div>
          <div className="game-card-info" style={{ backgroundImage: game.gradient }}>
            <p className="game-title">{game.game_name}</p>
            <p className="game-provider">{game.provider?.name ? game.provider?.name : "Provider"}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default GameItem;
